export const DAILY_MANDATORY = [
    "Personal Hygiene",
    "Dirty laundry in basket or laundry room",
    "Clean laundry put away",
    "Personal study & prayers",
    "Work on goals",
    "Bed made",
    "Bedroom floor clear",
    "Family study & prayer"
];

export const WEEKLY_MANDATORY = [
    "30 minutes of yard work"
];

export const MONTHLY_MANDATORY = [
    "Deep clean bedroom",
    "Go through clothes, toys, stuff",
    "Deep clean bedroom closet"
];

export const AVATARS = {
    ryan: "ryan",
    leah: "leah",
    samantha: "samantha",
    connor: "connor",
    marie: "marie",
};

export const USERS = [
    { id: 'ryan', name: 'Ryan', avatar: '/images/ryan2.png' },
    { id: 'leah', name: 'Leah', avatar: '/images/leah2.png' },
    { id: 'samantha', name: 'Samantha', avatar: '/images/samantha2.png' },
    { id: 'connor', name: 'Connor', avatar: '/images/connor2.png' },
    { id: 'marie', name: 'Marie', avatar: '/images/marie2.png' },
];
